export const nonFalse = <T>(v: T): v is T extends false ? never : T => !!v;
